type CheckboxProps = {
  id?: string;
  name: string;
  children: any;
  value: boolean;
  onChange: (newValue: boolean) => void;
  onBlur?: (e: React.FocusEvent<HTMLInputElement>) => void;
};

const Checkbox = (props: CheckboxProps) => {
  return (
    <div className="flex items-center mb-4">
      <input
        id={props.id || props.name}
        type="checkbox"
        checked={props.value}
        onChange={(e) => props.onChange(e.target.checked)}
        onBlur={props.onBlur}
        className="w-4 h-4 text-blue-600 rounded focus:ring-blue-600 ring-offset-gray-800 focus:ring-2 bg-gray-700 border-gray-600"
      />
      <label htmlFor={props.id || props.name} className="ml-2 text-sm font-medium text-gray-300">
        {props.children}
      </label>
    </div>
  );
};

export default Checkbox;
